import { render } from "./PainelComponent.vue?vue&type=template&id=16e11f6a&scoped=true"
import script from "./PainelComponent.vue?vue&type=script&lang=js"
export * from "./PainelComponent.vue?vue&type=script&lang=js"

import "./PainelComponent.vue?vue&type=style&index=0&id=16e11f6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e11f6a"]])

export default __exports__